// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"17bdcae1","667":"68f4b9a2"}[chunkId] + ".chunk.js";
};